export const getStyles = () => ({
  confirmDialog: {
    '& .ms-Dialog-content': {
      marginBottom: '40px',

      '& p, & div': {
        marginBottom: '15px',
      },
    },

    '& .ms-Dialog-action': {
      marginBottom: '30px',
      float: 'left',

      '&:first-child': {
        marginLeft: '0',
      },
    },

    '& button.dialog-help': {
      fontSize: '14px',
    },
  },
});

export const warningBoxStyles = { root: { backgroundColor: '#EFF6FC' }, icon: { color: '#333333' }, text: { color: '#333333' } };
